import FlightDetailModal from "component/FlightSearch/FlightDetailsModal";
import {
    dateFormater,
    formatDate2,
    formatPrice,
    formatTime,
} from "helpers/common";
import { getPassengers } from "helpers/flightHelper";
import { useFlightContext } from "hooks/flight/useFlightContext";
import useApiClient from "hooks/useApiClient";
import useToggle from "hooks/useToggle";
import {
    Button,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    CardTitle,
    Image,
    Row,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BsArrowLeft, BsArrowRight, BsPerson, BsTicket } from "react-icons/bs";

const SideBar = () => {
    const { t, i18n } = useTranslation();
    const { urls } = useApiClient();
    const { airValidateResults, passengersInfos: travlersDetails, flightSearchParams } =
        useFlightContext();
    const flight = airValidateResults?.flight;
    const logoSrc = `${process.env.REACT_APP_STATIC_URL}/${urls.flight.airlines}/${flight?.bounds[0]?.airlines[0]}.png`;
    let logoSrc2;
    if (flight?.bounds?.length > 1)
        logoSrc2 = `${process.env.REACT_APP_STATIC_URL}/${urls.flight.airlines}/${flight?.bounds[1]?.airlines[0]}.png`;

    const { nrOfAdult, nrOfChild, nrOfInfant,nrOfSenior } = getPassengers(flight);
    const { isOpen, toggle } = useToggle();
    return (
        <Row className="g-4 px-2 md:px-0">
            <Card className="rounded-2 border">
                <CardHeader className="border-bottom bg-white">
                    <CardTitle
                        as="div"
                        className="text-default fs-5 fw-bold mb-0"
                    >
                        {t("fareSummary")}
                    </CardTitle>
                </CardHeader>
                <CardBody>
                    <div className=" d-flex flex-column gap-1 ">
                        <li className=" d-flex justify-content-between align-items-center">
                            <span className="text-default fs-6 fw-normal mb-0">
                                {t("baseFare")}
                            </span>
                            <span className="fs-5">
                                {formatPrice(
                                    flight?.recommendation?.price
                                        ?.detailed_price?.total
                                ).replace("DA", t("DA"))}
                            </span>
                        </li>
                        <li className=" d-flex justify-content-between align-items-center">
                            <span className="text-default fs-6 fw-normal mb-0">
                                {t("discount")}
                            </span>
                            <span className="fs-5 text-success">
                                {" "}
                                - 0,00 {"DA".replace("DA", t("DA"))}
                            </span>
                        </li>
                        <li className=" d-flex justify-content-between align-items-center">
                            <span className="text-default fs-6 fw-normal mb-0">
                                {t("otherServices")}
                            </span>
                            <span className="fs-5 text-danger">
                                {" "}
                                + 0,00 {"DA".replace("DA", t("DA"))}
                            </span>
                        </li>
                    </div>
                </CardBody>
                <div className="card-footer border-top bg-white  ">
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="text-default fs-5 fw-normal mb-0">
                            {t("total")}
                        </span>
                        <span className="text-default text-md fw-normal mb-0 fs-5">
                            {formatPrice(
                                flight?.recommendation?.price?.detailed_price
                                    ?.total
                            ).replace("DA", t("DA"))}
                        </span>
                    </div>
                </div>
            </Card>
            <Card className="border">
                <CardHeader className="border-bottom bg-white">
                    <div className="mb-0 text-default fw-bold fs-5">
                        {t("yourBooking")}
                    </div>
                </CardHeader>
                <CardBody>
                    <div className="d-flex gap-2 align-items-center ">
                        <BsTicket className="" />
                        {t("flightTicket")}
                    </div>
                    <div className="flex flex-row items-center gap-2 mt-2">
                        <Image src={logoSrc} className="w-[40px]" />
                        <h6 className="fw-normal mb-0 flex gap-2">
                            {flight?.bounds[0]?.departure?.locationId}{" "}
                            {i18n?.dir(i18n.language) !== "ltr" ? (
                                <BsArrowLeft />
                            ) : (
                                <BsArrowRight />
                            )}{" "}
                            {flight?.bounds[0]?.arrival?.locationId}
                        </h6>
                    </div>
                    <ul className="flex gap-2 text-sm mt-2">
                        <li className="nav-item">
                            {formatDate2(
                                flight?.bounds[0]?.departure?.full_date,
                                i18n.language
                            )}
                        </li>
                        <li className="nav-item">
                            {flight?.bounds[0]?.nbStops === 0
                                ? t("direct")
                                : flight?.bounds[0]?.nbStops === 1
                                ? t("stop1")
                                : `${t("stops")} : ${
                                      flight?.bounds[0]?.nbStops
                                  } `}
                        </li>
                        <li className="nav-item">
                            {formatTime(flight?.bounds[0]?.flightDuration)
                                .replace("hours", t("hours"))
                                .replace("hour", t("hours"))
                                .replace("mins", t("mins"))}
                        </li>
                    </ul>
                    {flight?.bounds?.length > 1 && <hr className="my-2" />}

                    {flight?.bounds?.length > 1 && (
                        <>
                            <div className="flex flex-row items-center gap-2 mt-2">
                                {flightSearchParams?.openReturn ? (
                                    <div className="flex flex-col items-start justify-center">
                                        <span className="text-xs font-semibold text-green-700 leading-tight">
                                            {t("openReturn")}
                                        </span>
                                        {flight?.bounds[1]?.departure?.full_date && (
                                            <>
                                                <span className="text-xs text-green-600 mt-0.5">
                                                    {t("until")}
                                                </span>
                                                <span className="text-xs text-green-600">
                                                    {formatDate2(flight?.bounds[1]?.departure?.full_date, i18n.language)}
                                                </span>
                                            </>
                                        )}
                                    </div>
                                ) : (
                                    <Image src={logoSrc2} className="w-[40px] " />
                                )}
                                <h6 className="fw-normal mb-0 flex gap-2">
                                    {flight?.bounds[0]?.departure?.locationId}{" "}
                                    {i18n?.dir(i18n.language) === "ltr" ? (
                                        <BsArrowLeft />
                                    ) : (
                                        <BsArrowRight />
                                    )}{" "}
                                    {flight?.bounds[0]?.arrival?.locationId}
                                </h6>
                            </div>
                            {!flightSearchParams?.openReturn && (
                                <ul className="nflex gap-2 text-sm mt-2">
                                    <li className="nav-item">
                                        {formatDate2(
                                            flight?.bounds[1]?.departure?.full_date,
                                            i18n.language
                                        )}
                                    </li>
                                    <li className="nav-item">
                                        {flight?.bounds[1]?.nbStops === 0
                                            ? t("direct")
                                            : flight?.bounds[1]?.nbStops === 1
                                            ? t("stop1")
                                            : `${t("stops")} : ${
                                                  flight?.bounds[0]?.nbStops
                                              } `}
                                    </li>
                                    <li className="nav-item">
                                        {formatTime(
                                            flight?.bounds[1]?.flightDuration
                                        )
                                            .replace("hours", t("hours"))
                                            .replace("hour", t("hours"))
                                            .replace("mins", t("mins"))}
                                    </li>
                                </ul>
                            )}
                        </>
                    )}
                    <hr className="my-2" />
                    <div className="d-flex align-items-center gap-2 mb-3">
                        <BsPerson className="" />
                        {t("travelerDetail")}
                    </div>
                    {Array.from(Array(nrOfAdult).keys()).map((_, index) => {
                        return (
                            <>
                                <h6 className="mb-0 font-semibold text-[16px] mt-2">
                                    {travlersDetails &&
                                        travlersDetails[
                                            `firstNameAdult${index + 1}`
                                        ] +
                                            " " +
                                            travlersDetails[
                                                `lastNameAdult${index + 1}`
                                            ]}
                                </h6>
                                <ul className="flex gap-2 mt-1 ps-2 text-sm">
                                    <li className="nav-item">{t("adult")}</li>
                                    <li className="nav-item">
                                        {(() => {
                                            const v = travlersDetails[`titleAdult${index + 1}`]?.value;
                                            return (v === t("Mr") || v === "Mr" || v === "Mr.")
                                                ? t("male") : t("female");
                                        })()}
                                    </li>
                                    <li className="nav-item">
                                        {dateFormater(
                                            travlersDetails[
                                                `dobAdult${index + 1}`
                                            ]
                                        )}
                                    </li>
                                </ul>
                            </>
                        );
                    })}
                    {Array.from(Array(nrOfChild).keys()).map((_, index) => {
                        return (
                            <>
                                <h6 className="mb-0 font-semibold text-[16px] mt-2">
                                    {travlersDetails[
                                        `firstNameChild${index + 1}`
                                    ] +
                                        " " +
                                        travlersDetails[
                                            `lastNameChild${index + 1}`
                                        ]}
                                </h6>
                                <ul className="flex gap-2 mt-1 ps-2 text-sm">
                                    <li className="nav-item">{t("child")}</li>
                                    <li className="nav-item">
                                        {(() => {
                                            const v = travlersDetails[`titleChild${index + 1}`]?.value;
                                            return (v === t("Mr") || v === "Mr" || v === "Mr.")
                                                ? t("male") : t("female");
                                        })()}
                                    </li>
                                    <li className="nav-item">
                                        {dateFormater(
                                            travlersDetails[
                                                `dobChild${index + 1}`
                                            ]
                                        )}
                                    </li>
                                </ul>
                            </>
                        );
                    })}
                    {Array.from(Array(nrOfInfant).keys()).map((_, index) => {
                        return (
                            <>
                                <h6 className="mb-0 font-semibold text-[16px] mt-2">
                                    {travlersDetails[
                                        `firstNameInfant${index + 1}`
                                    ] +
                                        " " +
                                        travlersDetails[
                                            `lastNameInfant${index + 1}`
                                        ]}
                                </h6>
                                <ul className="flex gap-2 mt-1 ps-2 text-sm">
                                    <li className="nav-item">{t("child")}</li>
                                    <li className="nav-item">
                                        {(() => {
                                            const v = travlersDetails[`titleInfant${index + 1}`]?.value;
                                            return (v === t("Mr") || v === "Mr" || v === "Mr.")
                                                ? t("male") : t("female");
                                        })()}
                                    </li>
                                    <li className="nav-item">
                                        {dateFormater(
                                            travlersDetails[
                                                `dobInfant${index + 1}`
                                            ]
                                        )}
                                    </li>
                                </ul>
                            </>
                        );
                    })}
                    {Array.from(Array(nrOfSenior).keys()).map((_, index) => {
                        return (
                            <>
                                <h6 className="mb-0 font-semibold text-[16px] mt-2">
                                    {travlersDetails[
                                        `firstNameSenior${index + 1}`
                                    ] +
                                        " " +
                                        travlersDetails[
                                            `lastNameSenior${index + 1}`
                                        ]}
                                </h6>
                                <ul className="flex gap-2 mt-1 ps-2 text-sm">
                                    <li className="nav-item">{t("senior")}</li>
                                    <li className="nav-item">
                                        {(() => {
                                            const v = travlersDetails[`titleSenior${index + 1}`]?.value;
                                            return (v === t("Mr") || v === "Mr" || v === "Mr.")
                                                ? t("male") : t("female");
                                        })()}
                                    </li>
                                    <li className="nav-item">
                                        {dateFormater(
                                            travlersDetails[
                                                `dobSenior${index + 1}`
                                            ]
                                        )}
                                    </li>
                                </ul>
                            </>
                        );
                    })}
                </CardBody>
                <CardFooter className="border-top p-2 bg-white">
                    <Button
                        onClick={toggle}
                        variant="link"
                        className="mb-0 p-0 s-link"
                    >
                        {t("reviewBooking")}
                    </Button>
                </CardFooter>
                <FlightDetailModal
                    isOpen={isOpen}
                    flight={flight}
                    toggle={toggle}
                />
            </Card>
            <Card className="border p-4">
                <CardTitle as="div" className="mb-3">
                    <div className="mb-0 text-default fs-5 fw-bold ">
                        {t("needHelp")}
                    </div>
                </CardTitle>
                <p className="mb-2">{t("needHelpDescription")}</p>
                <div className="text-default fs-4 fw-bold ">+213 770268725</div>
            </Card>
        </Row>
    );
};
export default SideBar;
